var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { class: ["csat-trust-score", _vm.embedded ? "csat-embedded" : "mt-4"] },
    [
      !_vm.embedded
        ? _c(
            "v-card",
            { staticClass: "mb-4" },
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v("AI Trust Score & CSAT")
              ]),
              _vm._v(" "),
              _vm.loadingConfig
                ? _c(
                    "v-card-text",
                    { staticClass: "text-xs-center pt-4" },
                    [
                      _c("v-progress-circular", {
                        staticClass: "primary--text",
                        attrs: { indeterminate: "" }
                      })
                    ],
                    1
                  )
                : _c(
                    "v-card-text",
                    [
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: !_vm.hideAnalysisPromptSections,
                                  expression: "!hideAnalysisPromptSections"
                                }
                              ],
                              staticClass: "pr-3",
                              attrs: { xs12: "", md6: "" }
                            },
                            [
                              _c("v-textarea", {
                                attrs: {
                                  label: "Prompt source a optimiser",
                                  "auto-grow": "",
                                  rows: "6",
                                  outline: "",
                                  hint:
                                    "Collez ici le prompt de base du bot si vous voulez generer automatiquement le scoring prompt.",
                                  "persistent-hint": ""
                                },
                                model: {
                                  value: _vm.sourcePrompt,
                                  callback: function($$v) {
                                    _vm.sourcePrompt = $$v
                                  },
                                  expression: "sourcePrompt"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "pl-3",
                              attrs: { xs12: "", md6: "" }
                            },
                            [
                              !_vm.hideAnalysisPromptSections
                                ? [
                                    _c(
                                      "div",
                                      { staticClass: "subheading mb-2" },
                                      [_vm._v("Scenarios CSAT")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "caption grey--text mb-2"
                                      },
                                      [
                                        _vm._v(
                                          "\n            Chaque scenario garde le meme niveau d'analyse et fait varier uniquement le niveau d'exigence.\n          "
                                        )
                                      ]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "scenario-button-grid mb-3"
                                      },
                                      _vm._l(_vm.scenarioOptions, function(
                                        scenario
                                      ) {
                                        return _c(
                                          "v-btn",
                                          {
                                            key: scenario.id,
                                            staticClass: "scenario-button",
                                            attrs: {
                                              color:
                                                _vm.selectedScenarioId ===
                                                scenario.id
                                                  ? "primary"
                                                  : "",
                                              outline:
                                                _vm.selectedScenarioId !==
                                                scenario.id,
                                              small: ""
                                            },
                                            on: {
                                              click: function($event) {
                                                return _vm.applyScenarioById(
                                                  scenario.id
                                                )
                                              }
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n              " +
                                                _vm._s(scenario.label) +
                                                "\n            "
                                            )
                                          ]
                                        )
                                      }),
                                      1
                                    ),
                                    _vm._v(" "),
                                    _c("v-text-field", {
                                      attrs: {
                                        label: "Commentaire de version",
                                        outline: "",
                                        clearable: ""
                                      },
                                      model: {
                                        value: _vm.saveComment,
                                        callback: function($$v) {
                                          _vm.saveComment = $$v
                                        },
                                        expression: "saveComment"
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      { staticClass: "tf-gap-wrap mt-2" },
                                      [
                                        _vm.draftBackup
                                          ? _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  flat: "",
                                                  color: "primary"
                                                },
                                                on: {
                                                  click: _vm.restoreDraftBackup
                                                }
                                              },
                                              [
                                                _vm._v(
                                                  "\n              Rollback du brouillon\n            "
                                                )
                                              ]
                                            )
                                          : _vm._e(),
                                        _vm._v(" "),
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "primary",
                                              loading: _vm.generatingPrompt,
                                              disabled:
                                                _vm.generatingPrompt ||
                                                !_vm.sourcePrompt.trim().length
                                            },
                                            on: {
                                              click: _vm.generateScoringPrompt
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n              Generer le scoring prompt\n            "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "secondary",
                                              loading: _vm.improvingPrompt,
                                              disabled: _vm.improvingPrompt
                                            },
                                            on: {
                                              click: _vm.improveScoringPrompt
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n              Improve\n            "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-btn",
                                          {
                                            attrs: {
                                              color: "success",
                                              loading: _vm.savingPrompt,
                                              disabled: _vm.savingPrompt
                                            },
                                            on: { click: _vm.saveScoringPrompt }
                                          },
                                          [
                                            _vm._v(
                                              "\n              Sauvegarder\n            "
                                            )
                                          ]
                                        )
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.feedbackMessage
                                      ? _c(
                                          "v-alert",
                                          {
                                            staticClass: "mt-3",
                                            attrs: {
                                              type: _vm.feedbackType,
                                              dismissible: ""
                                            }
                                          },
                                          [
                                            _vm._v(
                                              "\n            " +
                                                _vm._s(_vm.feedbackMessage) +
                                                "\n          "
                                            )
                                          ]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.selectedScenarioDefinition
                                      ? _c(
                                          "v-card",
                                          {
                                            staticClass:
                                              "mt-3 pa-3 csat-soft-card"
                                          },
                                          [
                                            _c(
                                              "div",
                                              { staticClass: "subheading" },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm
                                                      .selectedScenarioDefinition
                                                      .label
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "caption grey--text mt-1"
                                              },
                                              [
                                                _vm._v(
                                                  _vm._s(
                                                    _vm
                                                      .selectedScenarioDefinition
                                                      .description
                                                  )
                                                )
                                              ]
                                            ),
                                            _vm._v(" "),
                                            _c(
                                              "div",
                                              { staticClass: "mt-2 body-1" },
                                              [
                                                _c("strong", [
                                                  _vm._v("Niveau d'exigence :")
                                                ]),
                                                _vm._v(
                                                  " " +
                                                    _vm._s(
                                                      _vm
                                                        .selectedScenarioDefinition
                                                        .strictnessLabel
                                                    ) +
                                                    "\n            "
                                                )
                                              ]
                                            )
                                          ]
                                        )
                                      : _vm._e()
                                  ]
                                : _vm._e()
                            ],
                            2
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: !_vm.hideAnalysisPromptSections,
                              expression: "!hideAnalysisPromptSections"
                            }
                          ],
                          staticClass: "mt-3",
                          attrs: { row: "", wrap: "" }
                        },
                        [
                          _c(
                            "v-flex",
                            {
                              staticClass: "pr-3",
                              attrs: { xs12: "", md6: "" }
                            },
                            [
                              _c("v-textarea", {
                                attrs: {
                                  label: "Contexte et objectif",
                                  "auto-grow": "",
                                  rows: "6",
                                  outline: ""
                                },
                                model: {
                                  value: _vm.scoringSections.personality,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.scoringSections,
                                      "personality",
                                      $$v
                                    )
                                  },
                                  expression: "scoringSections.personality"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "pl-3",
                              attrs: { xs12: "", md6: "" }
                            },
                            [
                              _c("v-textarea", {
                                attrs: {
                                  label: "Definition du CSAT",
                                  "auto-grow": "",
                                  rows: "6",
                                  outline: ""
                                },
                                model: {
                                  value: _vm.scoringSections.mission,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.scoringSections,
                                      "mission",
                                      $$v
                                    )
                                  },
                                  expression: "scoringSections.mission"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "pr-3",
                              attrs: { xs12: "", md6: "" }
                            },
                            [
                              _c("v-textarea", {
                                attrs: {
                                  label: "Regles de traitement",
                                  "auto-grow": "",
                                  rows: "8",
                                  outline: ""
                                },
                                model: {
                                  value: _vm.scoringSections.evaluation_rules,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.scoringSections,
                                      "evaluation_rules",
                                      $$v
                                    )
                                  },
                                  expression: "scoringSections.evaluation_rules"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "pl-3",
                              attrs: { xs12: "", md6: "" }
                            },
                            [
                              _c("v-textarea", {
                                attrs: {
                                  label: "Format de sortie attendu",
                                  "auto-grow": "",
                                  rows: "8",
                                  outline: ""
                                },
                                model: {
                                  value: _vm.scoringSections.output_format,
                                  callback: function($$v) {
                                    _vm.$set(
                                      _vm.scoringSections,
                                      "output_format",
                                      $$v
                                    )
                                  },
                                  expression: "scoringSections.output_format"
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _vm.improvementResult
                        ? _c(
                            "v-layout",
                            {
                              staticClass: "mt-3",
                              attrs: { row: "", wrap: "" }
                            },
                            [
                              _c(
                                "v-flex",
                                { attrs: { xs12: "" } },
                                [
                                  _c(
                                    "v-card",
                                    { staticClass: "pa-3 csat-soft-card" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "subheading mb-2" },
                                        [
                                          _vm._v(
                                            "Resultat de l'amelioration IA"
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "csat-score-chip" },
                                        [
                                          _vm._v(
                                            "\n              Score prompt estime: "
                                          ),
                                          _c("strong", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.improvementResult.score
                                              ) + "/100"
                                            )
                                          ])
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "mt-3" }, [
                                        _c("strong", [_vm._v("Faiblesses")]),
                                        _vm._v(" "),
                                        _c(
                                          "ul",
                                          { staticClass: "csat-list" },
                                          _vm._l(
                                            _vm.improvementResult.weaknesses,
                                            function(item, index) {
                                              return _c(
                                                "li",
                                                { key: "weak-" + index },
                                                [_vm._v(_vm._s(item))]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "mt-3" }, [
                                        _c("strong", [
                                          _vm._v("Recommandations")
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "ul",
                                          { staticClass: "csat-list" },
                                          _vm._l(
                                            _vm.improvementResult
                                              .recommendations,
                                            function(item, index) {
                                              return _c(
                                                "li",
                                                { key: "rec-" + index },
                                                [_vm._v(_vm._s(item))]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { staticClass: "mt-4", attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            { attrs: { xs12: "" } },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass:
                                    "pa-3 csat-soft-card csat-calculate-card"
                                },
                                [
                                  _c("div", { staticClass: "body-1 mb-2" }, [
                                    _vm._v(
                                      "\n              L'analyse est réalisée sur les conversations issues de la période sélectionnée\n            "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "csat-action-row mt-3" },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: false,
                                              expression: "false"
                                            }
                                          ],
                                          attrs: {
                                            color: "primary",
                                            large: ""
                                          },
                                          on: { click: _vm.openAnalysisDialog }
                                        },
                                        [
                                          _vm._v(
                                            "\n                Lancer l'analyse\n              "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "primary",
                                            large: "",
                                            loading: _vm.calculating,
                                            disabled: _vm.calculating
                                          },
                                          on: { click: _vm.calculateCsatScore }
                                        },
                                        [
                                          _vm._v(
                                            "\n                Lancer l'analyse\n              "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          class: {
                                            "csat-toggle-active":
                                              _vm.showAdvanced
                                          },
                                          attrs: {
                                            color: _vm.showAdvanced
                                              ? "primary"
                                              : "",
                                            large: "",
                                            outline: !_vm.showAdvanced,
                                            dark: _vm.showAdvanced
                                          },
                                          on: { click: _vm.toggleAdvanced }
                                        },
                                        [
                                          _vm._v(
                                            "\n                Avance\n              "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.showAdvanced,
                                  expression: "showAdvanced"
                                }
                              ],
                              staticClass: "mt-3",
                              attrs: { xs12: "" }
                            },
                            [
                              _c(
                                "v-card",
                                { staticClass: "pa-3 csat-soft-card" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "subheading mb-3" },
                                    [_vm._v("Jeu de donnees")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "v-radio-group",
                                    {
                                      attrs: { row: "" },
                                      model: {
                                        value: _vm.inputType,
                                        callback: function($$v) {
                                          _vm.inputType = $$v
                                        },
                                        expression: "inputType"
                                      }
                                    },
                                    [
                                      _c("v-radio", {
                                        attrs: {
                                          label: "Periode affichee",
                                          value: "period"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("v-radio", {
                                        attrs: {
                                          label: "IDs de conversations",
                                          value: "ids"
                                        }
                                      }),
                                      _vm._v(" "),
                                      _c("v-radio", {
                                        attrs: {
                                          label: "CSV / texte",
                                          value: "csv"
                                        }
                                      })
                                    ],
                                    1
                                  ),
                                  _vm._v(" "),
                                  _vm.inputType === "ids"
                                    ? _c("v-textarea", {
                                        attrs: {
                                          label: "IDs de conversations",
                                          placeholder:
                                            "Ex: 123>session1, 456>session2",
                                          "auto-grow": "",
                                          rows: "4",
                                          outline: ""
                                        },
                                        model: {
                                          value: _vm.conversationIdsInput,
                                          callback: function($$v) {
                                            _vm.conversationIdsInput = $$v
                                          },
                                          expression: "conversationIdsInput"
                                        }
                                      })
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _vm.inputType === "csv"
                                    ? _c(
                                        "div",
                                        [
                                          _c("input", {
                                            ref: "csvInput",
                                            staticClass: "mb-2",
                                            attrs: {
                                              type: "file",
                                              accept: ".csv,.txt"
                                            },
                                            on: { change: _vm.readCsvFile }
                                          }),
                                          _vm._v(" "),
                                          _c("v-textarea", {
                                            attrs: {
                                              label: "Contenu CSV / texte",
                                              placeholder:
                                                "Collez des ids de conversations separes par virgule, point-virgule, espace ou retour ligne.",
                                              "auto-grow": "",
                                              rows: "4",
                                              outline: ""
                                            },
                                            model: {
                                              value: _vm.csvRawInput,
                                              callback: function($$v) {
                                                _vm.csvRawInput = $$v
                                              },
                                              expression: "csvRawInput"
                                            }
                                          })
                                        ],
                                        1
                                      )
                                    : _vm._e(),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "caption grey--text mt-2" },
                                    [
                                      _vm._v(
                                        "\n              Conversations disponibles sur la periode courante: " +
                                          _vm._s(
                                            _vm.availableConversationCount
                                          ) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _vm.isHistoryView && _vm.showInlineHistory
                            ? _c(
                                "v-flex",
                                { staticClass: "mt-3", attrs: { xs12: "" } },
                                [
                                  _c(
                                    "v-card",
                                    { staticClass: "pa-3 csat-soft-card" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "subheading mb-3" },
                                        [_vm._v("Historique")]
                                      ),
                                      _vm._v(" "),
                                      _c("wz-histo-chats", {
                                        attrs: {
                                          params: _vm.params,
                                          numChatsTotal: _vm.numChatsTotal
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.isHistoryView
                            ? _c(
                                "v-flex",
                                { staticClass: "mt-3", attrs: { xs12: "" } },
                                [
                                  _c(
                                    "v-card",
                                    { staticClass: "pa-3 csat-soft-card" },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "subheading mb-3" },
                                        [_vm._v("Historique")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-layout",
                                        { attrs: { row: "", wrap: "" } },
                                        [
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "pr-3",
                                              attrs: { xs12: "", md6: "" }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "subheading mb-2"
                                                },
                                                [
                                                  _vm._v(
                                                    "Versions du scoring prompt"
                                                  )
                                                ]
                                              ),
                                              _vm._v(" "),
                                              _c("v-data-table", {
                                                staticClass: "elevation-1",
                                                attrs: {
                                                  headers: _vm.versionHeaders,
                                                  items: _vm.promptVersions,
                                                  "rows-per-page-items": [
                                                    5,
                                                    10,
                                                    20
                                                  ]
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "items",
                                                      fn: function(props) {
                                                        return [
                                                          _c("tr", [
                                                            _c("td", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.formatDateTime(
                                                                    props.item
                                                                      .created_at
                                                                  )
                                                                )
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("td", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  props.item
                                                                    .created_by
                                                                )
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("td", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  props.item
                                                                    .scenario_label ||
                                                                    "-"
                                                                )
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("td", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  props.item
                                                                    .comment
                                                                )
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c(
                                                              "td",
                                                              {
                                                                staticClass:
                                                                  "text-xs-right"
                                                              },
                                                              [
                                                                _c(
                                                                  "v-btn",
                                                                  {
                                                                    attrs: {
                                                                      small: "",
                                                                      flat: "",
                                                                      color:
                                                                        "primary"
                                                                    },
                                                                    on: {
                                                                      click: function(
                                                                        $event
                                                                      ) {
                                                                        return _vm.restoreVersion(
                                                                          props.item
                                                                        )
                                                                      }
                                                                    }
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      "Restaurer"
                                                                    )
                                                                  ]
                                                                )
                                                              ],
                                                              1
                                                            )
                                                          ])
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  1279917962
                                                )
                                              })
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "v-flex",
                                            {
                                              staticClass: "pl-3",
                                              attrs: { xs12: "", md6: "" }
                                            },
                                            [
                                              _c(
                                                "div",
                                                {
                                                  staticClass: "subheading mb-2"
                                                },
                                                [_vm._v("Runs precedents")]
                                              ),
                                              _vm._v(" "),
                                              _c("v-data-table", {
                                                staticClass: "elevation-1",
                                                attrs: {
                                                  headers: _vm.runHeaders,
                                                  items: _vm.runHistory,
                                                  "rows-per-page-items": [
                                                    5,
                                                    10,
                                                    20
                                                  ]
                                                },
                                                scopedSlots: _vm._u(
                                                  [
                                                    {
                                                      key: "items",
                                                      fn: function(props) {
                                                        return [
                                                          _c("tr", [
                                                            _c("td", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.formatDateTime(
                                                                    props.item
                                                                      .created_at
                                                                  )
                                                                )
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("td", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  props.item
                                                                    .label ||
                                                                    props.item
                                                                      .input_type
                                                                )
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("td", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  props.item
                                                                    .scenario_label ||
                                                                    "-"
                                                                )
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("td", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  props.item
                                                                    .global_score
                                                                )
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("td", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  props.item
                                                                    .conversation_count
                                                                )
                                                              )
                                                            ]),
                                                            _vm._v(" "),
                                                            _c("td", [
                                                              _vm._v(
                                                                _vm._s(
                                                                  props.item
                                                                    .error_count
                                                                )
                                                              )
                                                            ])
                                                          ])
                                                        ]
                                                      }
                                                    }
                                                  ],
                                                  null,
                                                  false,
                                                  3773379870
                                                )
                                              })
                                            ],
                                            1
                                          )
                                        ],
                                        1
                                      )
                                    ],
                                    1
                                  )
                                ],
                                1
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
            ],
            1
          )
        : _c("div", [
            _vm.loadingConfig
              ? _c(
                  "div",
                  { staticClass: "text-xs-center pt-4" },
                  [
                    _c("v-progress-circular", {
                      staticClass: "primary--text",
                      attrs: { indeterminate: "" }
                    })
                  ],
                  1
                )
              : _c(
                  "div",
                  { staticClass: "csat-embedded-body" },
                  [
                    _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "" } },
                      [
                        _vm.isLeftView
                          ? _c("v-flex", { attrs: { xs12: "" } }, [
                              _c("div", { staticClass: "csat-left-topbar" }, [
                                _c(
                                  "div",
                                  { staticClass: "csat-inline-icon-actions" },
                                  [
                                    _c(
                                      "v-tooltip",
                                      { attrs: { bottom: "" } },
                                      [
                                        _c(
                                          "template",
                                          { slot: "activator" },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  icon: "",
                                                  small: "",
                                                  ripple: false,
                                                  flat: !_vm.showAdvanced,
                                                  color: _vm.showAdvanced
                                                    ? "accent"
                                                    : ""
                                                },
                                                on: {
                                                  click: _vm.toggleAdvanced
                                                }
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      dark: _vm.showAdvanced
                                                    }
                                                  },
                                                  [_vm._v("tune")]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("span", [_vm._v("Avance")])
                                      ],
                                      2
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-tooltip",
                                      { attrs: { bottom: "" } },
                                      [
                                        _c(
                                          "template",
                                          { slot: "activator" },
                                          [
                                            _c(
                                              "v-btn",
                                              {
                                                attrs: {
                                                  icon: "",
                                                  small: "",
                                                  ripple: false,
                                                  flat: !_vm.historyActive,
                                                  color: _vm.historyActive
                                                    ? "accent"
                                                    : ""
                                                },
                                                on: { click: _vm.toggleHistory }
                                              },
                                              [
                                                _c(
                                                  "v-icon",
                                                  {
                                                    attrs: {
                                                      dark: _vm.historyActive
                                                    }
                                                  },
                                                  [_vm._v("history")]
                                                )
                                              ],
                                              1
                                            )
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c("span", [_vm._v("Historique")])
                                      ],
                                      2
                                    )
                                  ],
                                  1
                                )
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "csat-left-action-area" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "csat-action-row" },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: false,
                                              expression: "false"
                                            }
                                          ],
                                          attrs: {
                                            color: "primary",
                                            large: ""
                                          },
                                          on: { click: _vm.openAnalysisDialog }
                                        },
                                        [
                                          _vm._v(
                                            "\n                Lancer l'analyse\n              "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-tooltip",
                                        { attrs: { bottom: "" } },
                                        [
                                          _c(
                                            "template",
                                            { slot: "activator" },
                                            [
                                              _c(
                                                "v-btn",
                                                {
                                                  attrs: {
                                                    color: "primary",
                                                    large: "",
                                                    loading: _vm.calculating,
                                                    disabled: _vm.calculating
                                                  },
                                                  on: {
                                                    click:
                                                      _vm.calculateCsatScore
                                                  }
                                                },
                                                [
                                                  _vm._v(
                                                    "\n                    Lancer l'analyse\n                  "
                                                  )
                                                ]
                                              )
                                            ],
                                            1
                                          ),
                                          _vm._v(" "),
                                          _c("span", [
                                            _vm._v(
                                              "L'analyse est realisee sur les conversations issues de la periode selectionnee"
                                            )
                                          ])
                                        ],
                                        2
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ])
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isLeftView
                          ? _c(
                              "v-flex",
                              {
                                directives: [
                                  {
                                    name: "show",
                                    rawName: "v-show",
                                    value: _vm.showAdvanced,
                                    expression: "showAdvanced"
                                  }
                                ],
                                staticClass: "mt-3",
                                attrs: { xs12: "" }
                              },
                              [
                                _c(
                                  "v-card",
                                  { staticClass: "pa-3 csat-soft-card" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "subheading mb-3" },
                                      [_vm._v("Jeu de donnees")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-radio-group",
                                      {
                                        attrs: { row: "" },
                                        model: {
                                          value: _vm.inputType,
                                          callback: function($$v) {
                                            _vm.inputType = $$v
                                          },
                                          expression: "inputType"
                                        }
                                      },
                                      [
                                        _c("v-radio", {
                                          attrs: {
                                            label: "Periode affichee",
                                            value: "period"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("v-radio", {
                                          attrs: {
                                            label: "IDs de conversations",
                                            value: "ids"
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("v-radio", {
                                          attrs: {
                                            label: "CSV / texte",
                                            value: "csv"
                                          }
                                        })
                                      ],
                                      1
                                    ),
                                    _vm._v(" "),
                                    _vm.inputType === "ids"
                                      ? _c("v-textarea", {
                                          attrs: {
                                            label: "IDs de conversations",
                                            placeholder:
                                              "Ex: 123>session1, 456>session2",
                                            "auto-grow": "",
                                            rows: "4",
                                            outline: ""
                                          },
                                          model: {
                                            value: _vm.conversationIdsInput,
                                            callback: function($$v) {
                                              _vm.conversationIdsInput = $$v
                                            },
                                            expression: "conversationIdsInput"
                                          }
                                        })
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.inputType === "csv"
                                      ? _c(
                                          "div",
                                          [
                                            _c("input", {
                                              ref: "csvInput",
                                              staticClass: "mb-2",
                                              attrs: {
                                                type: "file",
                                                accept: ".csv,.txt"
                                              },
                                              on: { change: _vm.readCsvFile }
                                            }),
                                            _vm._v(" "),
                                            _c("v-textarea", {
                                              attrs: {
                                                label: "Contenu CSV / texte",
                                                placeholder:
                                                  "Collez des ids de conversations separes par virgule, point-virgule, espace ou retour ligne.",
                                                "auto-grow": "",
                                                rows: "4",
                                                outline: ""
                                              },
                                              model: {
                                                value: _vm.csvRawInput,
                                                callback: function($$v) {
                                                  _vm.csvRawInput = $$v
                                                },
                                                expression: "csvRawInput"
                                              }
                                            })
                                          ],
                                          1
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _c(
                                      "div",
                                      {
                                        staticClass: "caption grey--text mt-2"
                                      },
                                      [
                                        _vm._v(
                                          "\n              Conversations disponibles sur la periode courante: " +
                                            _vm._s(
                                              _vm.availableConversationCount
                                            ) +
                                            "\n            "
                                        )
                                      ]
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isHistoryView && _vm.showInlineHistory
                          ? _c(
                              "v-flex",
                              { attrs: { xs12: "" } },
                              [
                                _c(
                                  "v-card",
                                  { staticClass: "pa-3 csat-soft-card" },
                                  [
                                    _c(
                                      "div",
                                      { staticClass: "subheading mb-3" },
                                      [_vm._v("Historique")]
                                    ),
                                    _vm._v(" "),
                                    _c("wz-histo-chats", {
                                      attrs: {
                                        params: _vm.params,
                                        numChatsTotal: _vm.numChatsTotal
                                      }
                                    })
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isHistoryView
                          ? _c(
                              "v-flex",
                              { attrs: { xs12: "" } },
                              [
                                _c(
                                  "v-card",
                                  { staticClass: "pa-3 csat-soft-card" },
                                  [
                                    _c(
                                      "div",
                                      {
                                        staticClass:
                                          "subheading font-weight-bold grey--text"
                                      },
                                      [_vm._v("Historique")]
                                    ),
                                    _vm._v(" "),
                                    _c(
                                      "v-expansion-panel",
                                      [
                                        _c(
                                          "v-expansion-panel-content",
                                          {
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "header",
                                                  fn: function() {
                                                    return [
                                                      _c("div", [
                                                        _vm._v(
                                                          "Versions du scoring prompt"
                                                        )
                                                      ])
                                                    ]
                                                  },
                                                  proxy: true
                                                }
                                              ],
                                              null,
                                              false,
                                              1610300991
                                            )
                                          },
                                          [
                                            _vm._v(" "),
                                            _c("v-data-table", {
                                              staticClass: "elevation-1",
                                              attrs: {
                                                headers: _vm.versionHeaders,
                                                items: _vm.promptVersions,
                                                "rows-per-page-items": [
                                                  5,
                                                  10,
                                                  20
                                                ]
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "items",
                                                    fn: function(props) {
                                                      return [
                                                        _c("tr", [
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.formatDateTime(
                                                                  props.item
                                                                    .created_at
                                                                )
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                props.item
                                                                  .created_by
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                props.item
                                                                  .scenario_label ||
                                                                  "-"
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                props.item
                                                                  .comment
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c(
                                                            "td",
                                                            {
                                                              staticClass:
                                                                "text-xs-right"
                                                            },
                                                            [
                                                              _c(
                                                                "v-btn",
                                                                {
                                                                  attrs: {
                                                                    small: "",
                                                                    flat: "",
                                                                    color:
                                                                      "primary"
                                                                  },
                                                                  on: {
                                                                    click: function(
                                                                      $event
                                                                    ) {
                                                                      return _vm.restoreVersion(
                                                                        props.item
                                                                      )
                                                                    }
                                                                  }
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    "Restaurer"
                                                                  )
                                                                ]
                                                              )
                                                            ],
                                                            1
                                                          )
                                                        ])
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                false,
                                                1279917962
                                              )
                                            })
                                          ],
                                          1
                                        ),
                                        _vm._v(" "),
                                        _c(
                                          "v-expansion-panel-content",
                                          {
                                            scopedSlots: _vm._u(
                                              [
                                                {
                                                  key: "header",
                                                  fn: function() {
                                                    return [
                                                      _c("div", [
                                                        _vm._v(
                                                          "Runs precedents"
                                                        )
                                                      ])
                                                    ]
                                                  },
                                                  proxy: true
                                                }
                                              ],
                                              null,
                                              false,
                                              200178141
                                            )
                                          },
                                          [
                                            _vm._v(" "),
                                            _c("v-data-table", {
                                              staticClass: "elevation-1",
                                              attrs: {
                                                headers: _vm.runHeaders,
                                                items: _vm.runHistory,
                                                "rows-per-page-items": [
                                                  5,
                                                  10,
                                                  20
                                                ]
                                              },
                                              scopedSlots: _vm._u(
                                                [
                                                  {
                                                    key: "items",
                                                    fn: function(props) {
                                                      return [
                                                        _c("tr", [
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                _vm.formatDateTime(
                                                                  props.item
                                                                    .created_at
                                                                )
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                props.item
                                                                  .label ||
                                                                  props.item
                                                                    .input_type
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                props.item
                                                                  .scenario_label ||
                                                                  "-"
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                props.item
                                                                  .global_score
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                props.item
                                                                  .conversation_count
                                                              )
                                                            )
                                                          ]),
                                                          _vm._v(" "),
                                                          _c("td", [
                                                            _vm._v(
                                                              _vm._s(
                                                                props.item
                                                                  .error_count
                                                              )
                                                            )
                                                          ])
                                                        ])
                                                      ]
                                                    }
                                                  }
                                                ],
                                                null,
                                                false,
                                                3773379870
                                              )
                                            })
                                          ],
                                          1
                                        )
                                      ],
                                      1
                                    )
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ],
                  1
                )
          ]),
      _vm._v(" "),
      _c(
        "v-dialog",
        {
          attrs: {
            "max-width": "1100",
            "content-class": "csat-analysis-dialog-wrapper",
            persistent: ""
          },
          model: {
            value: _vm.showAnalysisDialog,
            callback: function($$v) {
              _vm.showAnalysisDialog = $$v
            },
            expression: "showAnalysisDialog"
          }
        },
        [
          _c(
            "v-card",
            { staticClass: "csat-analysis-dialog" },
            [
              _c(
                "div",
                { staticClass: "csat-dialog-header primary" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { icon: "" },
                      on: { click: _vm.closeAnalysisDialog }
                    },
                    [
                      _c("v-icon", { staticClass: "white--text" }, [
                        _vm._v("close")
                      ])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c("div", { staticClass: "csat-dialog-title white--text" }, [
                    _vm._v("Analyse CSAT guidee")
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "div",
                { staticClass: "csat-stepper-top" },
                [
                  _c(
                    "v-stepper",
                    {
                      attrs: { "non-linear": "", flat: "" },
                      model: {
                        value: _vm.analysisDialogStep,
                        callback: function($$v) {
                          _vm.analysisDialogStep = $$v
                        },
                        expression: "analysisDialogStep"
                      }
                    },
                    [
                      _c(
                        "v-stepper-header",
                        [
                          _c(
                            "v-stepper-step",
                            {
                              attrs: {
                                complete: _vm.analysisDialogStep > 1,
                                step: "1"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.setAnalysisDialogStep(1)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              Prompt du bot\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "v-stepper-step",
                            {
                              attrs: {
                                complete: _vm.analysisDialogStep > 2,
                                step: "2"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.setAnalysisDialogStep(2)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              Prompt CSAT\n            "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "v-stepper-step",
                            {
                              attrs: {
                                complete: _vm.analysisDialogStep > 3,
                                step: "3"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.setAnalysisDialogStep(3)
                                }
                              }
                            },
                            [_vm._v("\n              Calculate\n            ")]
                          ),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "v-stepper-step",
                            {
                              attrs: {
                                complete: _vm.analysisDialogStep > 4,
                                step: "4"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.setAnalysisDialogStep(4)
                                }
                              }
                            },
                            [_vm._v("\n              Resultats\n            ")]
                          ),
                          _vm._v(" "),
                          _c("v-divider"),
                          _vm._v(" "),
                          _c(
                            "v-stepper-step",
                            {
                              attrs: {
                                complete: _vm.analysisDialogStep > 5,
                                step: "5"
                              },
                              on: {
                                click: function($event) {
                                  return _vm.setAnalysisDialogStep(5)
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              Recommandation\n            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-text",
                { staticClass: "pt-4 csat-dialog-content" },
                [
                  _vm.analysisDialogLoading
                    ? _c("v-progress-linear", {
                        staticClass: "mb-4",
                        attrs: { indeterminate: "", color: "primary" }
                      })
                    : _vm._e(),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.analysisDialogStep === 1,
                          expression: "analysisDialogStep === 1"
                        }
                      ],
                      staticClass: "csat-step-pane csat-step-pane-bot"
                    },
                    [
                      _c("div", { staticClass: "subheading mb-3" }, [
                        _vm._v("Prompt du chatbot actuellement utilise")
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "csat-step-pane-body" }, [
                        _c("textarea", {
                          staticClass: "csat-native-textarea",
                          attrs: { readonly: "" },
                          domProps: { value: _vm.analysisDialogBotPrompt }
                        })
                      ])
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.analysisDialogStep === 2,
                          expression: "analysisDialogStep === 2"
                        }
                      ],
                      staticClass: "csat-step-pane"
                    },
                    [
                      _c("div", { staticClass: "subheading mb-3" }, [
                        _vm._v("Prompts dedies au calcul du CSAT")
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              staticClass: "pr-3",
                              attrs: { xs12: "", md6: "" }
                            },
                            [
                              _c("v-textarea", {
                                staticClass: "csat-dialog-textarea",
                                attrs: {
                                  value:
                                    _vm.analysisDialogCsatSections.personality,
                                  label: "Contexte et objectif",
                                  "auto-grow": "",
                                  rows: "5",
                                  outline: "",
                                  readonly: ""
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "pl-3",
                              attrs: { xs12: "", md6: "" }
                            },
                            [
                              _c("v-textarea", {
                                staticClass: "csat-dialog-textarea",
                                attrs: {
                                  value: _vm.analysisDialogCsatSections.mission,
                                  label: "Definition du CSAT",
                                  "auto-grow": "",
                                  rows: "5",
                                  outline: "",
                                  readonly: ""
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "pr-3",
                              attrs: { xs12: "", md6: "" }
                            },
                            [
                              _c("v-textarea", {
                                staticClass: "csat-dialog-textarea",
                                attrs: {
                                  value:
                                    _vm.analysisDialogCsatSections
                                      .evaluation_rules,
                                  label: "Regles de traitement",
                                  "auto-grow": "",
                                  rows: "5",
                                  outline: "",
                                  readonly: ""
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "pl-3",
                              attrs: { xs12: "", md6: "" }
                            },
                            [
                              _c("v-textarea", {
                                staticClass: "csat-dialog-textarea",
                                attrs: {
                                  value:
                                    _vm.analysisDialogCsatSections
                                      .output_format,
                                  label: "Format de sortie attendu",
                                  "auto-grow": "",
                                  rows: "5",
                                  outline: "",
                                  readonly: ""
                                }
                              })
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.analysisDialogStep === 3,
                          expression: "analysisDialogStep === 3"
                        }
                      ],
                      staticClass: "csat-step-pane"
                    },
                    [
                      _c("div", { staticClass: "subheading mb-3" }, [
                        _vm._v("Calculate")
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "csat-step-loader" },
                        [
                          _c("v-progress-circular", {
                            attrs: {
                              indeterminate: "",
                              color: "primary",
                              size: 64,
                              width: 4
                            }
                          }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass:
                                "mt-3 body-1 grey--text text--darken-1"
                            },
                            [_vm._v("Calcul du score CSAT en cours...")]
                          )
                        ],
                        1
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.analysisDialogStep === 4,
                          expression: "analysisDialogStep === 4"
                        }
                      ],
                      staticClass: "csat-step-pane csat-step-pane-results"
                    },
                    [
                      _c("div", { staticClass: "subheading mb-3" }, [
                        _vm._v("Resultats")
                      ]),
                      _vm._v(" "),
                      _vm.analysisDialogResultSummary
                        ? _c(
                            "v-layout",
                            {
                              staticClass: "ma-0",
                              attrs: { row: "", wrap: "" }
                            },
                            [
                              _c(
                                "v-flex",
                                {
                                  staticClass: "pa-0 pr-3",
                                  attrs: { xs12: "", md4: "" }
                                },
                                [
                                  _c(
                                    "v-card",
                                    {
                                      staticClass:
                                        "pa-4 text-xs-center csat-soft-card csat-score-card"
                                    },
                                    [
                                      _c(
                                        "div",
                                        { staticClass: "caption grey--text" },
                                        [_vm._v("AI CSAT Score")]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "display-2 primary--text font-weight-bold"
                                        },
                                        [
                                          _vm._v(
                                            _vm._s(
                                              _vm.analysisDialogResultSummary
                                                .global_score
                                            )
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        { staticClass: "caption grey--text" },
                                        [_vm._v("/100")]
                                      ),
                                      _vm._v(" "),
                                      _vm.analysisDialogPreviousSummary
                                        ? _c("div", { staticClass: "mt-3" }, [
                                            _c(
                                              "span",
                                              {
                                                staticClass:
                                                  "caption grey--text"
                                              },
                                              [_vm._v("Periode precedente: ")]
                                            ),
                                            _vm._v(" "),
                                            _c("strong", [
                                              _vm._v(
                                                _vm._s(
                                                  _vm
                                                    .analysisDialogPreviousSummary
                                                    .global_score
                                                )
                                              )
                                            ])
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      _vm.analysisDialogPreviousSummary
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "mt-1 font-weight-bold",
                                              class:
                                                _vm.analysisDialogDeltaClass
                                            },
                                            [
                                              _vm._v(
                                                "\n                  " +
                                                  _vm._s(
                                                    _vm.analysisDialogFormattedDelta
                                                  ) +
                                                  "\n                "
                                              )
                                            ]
                                          )
                                        : _vm._e()
                                    ]
                                  )
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "v-flex",
                                {
                                  staticClass: "pa-0",
                                  attrs: { xs12: "", md8: "" }
                                },
                                [
                                  _c(
                                    "v-card",
                                    {
                                      staticClass:
                                        "pa-4 csat-soft-card csat-result-details-card"
                                    },
                                    [
                                      _c("div", [
                                        _vm._v(
                                          "\n                  Conversations scorees : "
                                        ),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.analysisDialogResultSummary
                                                .conversation_count
                                            )
                                          )
                                        ]),
                                        _c("br"),
                                        _vm._v(
                                          "\n                  Erreurs non bloquantes : "
                                        ),
                                        _c("strong", [
                                          _vm._v(
                                            _vm._s(
                                              _vm.analysisDialogResultSummary
                                                .error_count
                                            )
                                          )
                                        ])
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "mt-3" }, [
                                        _c("strong", [_vm._v("Insights")]),
                                        _vm._v(" "),
                                        _c(
                                          "ul",
                                          { staticClass: "csat-list" },
                                          _vm._l(
                                            _vm.analysisDialogResultSummary
                                              .insights,
                                            function(item, index) {
                                              return _c(
                                                "li",
                                                {
                                                  key: "dialog-insight-" + index
                                                },
                                                [_vm._v(_vm._s(item))]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      ]),
                                      _vm._v(" "),
                                      _c("div", { staticClass: "mt-3" }, [
                                        _c("strong", [
                                          _vm._v("Recommandations")
                                        ]),
                                        _vm._v(" "),
                                        _c(
                                          "ul",
                                          { staticClass: "csat-list" },
                                          _vm._l(
                                            _vm.analysisDialogResultSummary
                                              .recommendations,
                                            function(item, index) {
                                              return _c(
                                                "li",
                                                { key: "dialog-rec-" + index },
                                                [_vm._v(_vm._s(item))]
                                              )
                                            }
                                          ),
                                          0
                                        )
                                      ])
                                    ]
                                  )
                                ],
                                1
                              )
                            ],
                            1
                          )
                        : _vm.analysisDialogResultError
                        ? _c(
                            "v-alert",
                            { attrs: { type: "error", value: "true" } },
                            [
                              _vm._v(
                                "\n            " +
                                  _vm._s(_vm.analysisDialogResultError) +
                                  "\n          "
                              )
                            ]
                          )
                        : _vm._e()
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    {
                      directives: [
                        {
                          name: "show",
                          rawName: "v-show",
                          value: _vm.analysisDialogStep === 5,
                          expression: "analysisDialogStep === 5"
                        }
                      ],
                      staticClass: "csat-step-pane csat-step-pane-results"
                    },
                    [
                      _c("div", { staticClass: "subheading mb-3" }, [
                        _vm._v("Recommandation")
                      ]),
                      _vm._v(" "),
                      _c(
                        "v-layout",
                        { staticClass: "ma-0", attrs: { row: "", wrap: "" } },
                        [
                          _c(
                            "v-flex",
                            {
                              staticClass: "pa-0 pr-3",
                              attrs: { xs12: "", md6: "" }
                            },
                            [
                              _c("div", { staticClass: "subheading mb-2" }, [
                                _vm._v("Runs precedents")
                              ]),
                              _vm._v(" "),
                              _c("v-data-table", {
                                staticClass: "elevation-1",
                                attrs: {
                                  headers: _vm.runHeaders,
                                  items: _vm.runHistory,
                                  "rows-per-page-items": [5, 10, 20]
                                },
                                scopedSlots: _vm._u([
                                  {
                                    key: "items",
                                    fn: function(props) {
                                      return [
                                        _c("tr", [
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                _vm.formatDateTime(
                                                  props.item.created_at
                                                )
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                props.item.label ||
                                                  props.item.input_type
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                props.item.scenario_label || "-"
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(props.item.global_score)
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(
                                                props.item.conversation_count
                                              )
                                            )
                                          ]),
                                          _vm._v(" "),
                                          _c("td", [
                                            _vm._v(
                                              _vm._s(props.item.error_count)
                                            )
                                          ])
                                        ])
                                      ]
                                    }
                                  }
                                ])
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "v-flex",
                            {
                              staticClass: "pa-0",
                              attrs: { xs12: "", md6: "" }
                            },
                            [
                              _c(
                                "v-card",
                                {
                                  staticClass:
                                    "pa-4 csat-soft-card csat-result-details-card"
                                },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "subheading mb-3" },
                                    [_vm._v("Que veux-tu ameliorer ?")]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "body-1 mb-3" }, [
                                    _vm._v(
                                      "\n                  A partir du score obtenu, tu peux soit retravailler le prompt CSAT de notation, soit retravailler le prompt systeme du chatbot.\n                "
                                    )
                                  ]),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "tf-gap-wrap" },
                                    [
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: { color: "primary" },
                                          on: {
                                            click: function($event) {
                                              return _vm.setAnalysisDialogStep(
                                                2
                                              )
                                            }
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    Ameliorer le prompt CSAT\n                  "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "v-btn",
                                        {
                                          attrs: {
                                            color: "primary",
                                            outline: ""
                                          },
                                          on: {
                                            click:
                                              _vm.goToBotbuilderPromptSystem
                                          }
                                        },
                                        [
                                          _vm._v(
                                            "\n                    Ameliorer le prompt du chatbot\n                  "
                                          )
                                        ]
                                      )
                                    ],
                                    1
                                  )
                                ]
                              )
                            ],
                            1
                          )
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-card-actions",
                { staticClass: "csat-dialog-actions" },
                [
                  _c(
                    "v-btn",
                    {
                      attrs: { flat: "" },
                      on: { click: _vm.closeAnalysisDialog }
                    },
                    [_vm._v("\n          Fermer\n        ")]
                  ),
                  _vm._v(" "),
                  _c("v-spacer"),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        flat: "",
                        disabled:
                          _vm.analysisDialogStep === 1 ||
                          _vm.analysisDialogCalculating
                      },
                      on: { click: _vm.goToPreviousAnalysisStep }
                    },
                    [_vm._v("\n          Precedent\n        ")]
                  ),
                  _vm._v(" "),
                  _c(
                    "v-btn",
                    {
                      attrs: {
                        color: "primary",
                        disabled:
                          _vm.analysisDialogStep >= _vm.analysisDialogMaxStep ||
                          _vm.analysisDialogCalculating
                      },
                      on: { click: _vm.goToNextAnalysisStep }
                    },
                    [_vm._v("\n          Suivant\n        ")]
                  )
                ],
                1
              )
            ],
            1
          )
        ],
        1
      ),
      _vm._v(" "),
      !_vm.embedded && _vm.resultSummary
        ? _c(
            "v-card",
            { staticClass: "mb-4" },
            [
              _c("v-card-title", { staticClass: "headline" }, [
                _vm._v("Resultats")
              ]),
              _vm._v(" "),
              _c(
                "v-card-text",
                [
                  _c(
                    "v-layout",
                    { attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { staticClass: "pr-3", attrs: { xs12: "", md4: "" } },
                        [
                          _c(
                            "v-card",
                            {
                              staticClass:
                                "pa-4 text-xs-center csat-soft-card csat-score-card"
                            },
                            [
                              _c("div", { staticClass: "caption grey--text" }, [
                                _vm._v("AI CSAT Score")
                              ]),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "display-2 primary--text font-weight-bold"
                                },
                                [_vm._v(_vm._s(_vm.resultSummary.global_score))]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "caption grey--text" }, [
                                _vm._v("/100")
                              ]),
                              _vm._v(" "),
                              _vm.previousSummary
                                ? _c("div", { staticClass: "mt-3" }, [
                                    _c(
                                      "span",
                                      { staticClass: "caption grey--text" },
                                      [_vm._v("Periode precedente: ")]
                                    ),
                                    _vm._v(" "),
                                    _c("strong", [
                                      _vm._v(
                                        _vm._s(_vm.previousSummary.global_score)
                                      )
                                    ])
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _vm.previousSummary
                                ? _c(
                                    "div",
                                    {
                                      staticClass: "mt-1 font-weight-bold",
                                      class: _vm.deltaClass
                                    },
                                    [
                                      _vm._v(
                                        "\n              " +
                                          _vm._s(_vm.formattedDelta) +
                                          "\n            "
                                      )
                                    ]
                                  )
                                : _vm._e()
                            ]
                          )
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { staticClass: "pl-3", attrs: { xs12: "", md8: "" } },
                        [
                          _c("v-card", { staticClass: "pa-4 csat-soft-card" }, [
                            _c("div", [
                              _c("strong", [_vm._v("Conversations scorees:")]),
                              _vm._v(
                                " " +
                                  _vm._s(_vm.resultSummary.conversation_count)
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", [
                              _c("strong", [_vm._v("Erreurs non bloquantes:")]),
                              _vm._v(
                                " " + _vm._s(_vm.resultSummary.error_count)
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "mt-3" }, [
                              _c("strong", [_vm._v("Insights")]),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "csat-list" },
                                _vm._l(_vm.resultSummary.insights, function(
                                  item,
                                  index
                                ) {
                                  return _c("li", { key: "insight-" + index }, [
                                    _vm._v(_vm._s(item))
                                  ])
                                }),
                                0
                              )
                            ]),
                            _vm._v(" "),
                            _c("div", { staticClass: "mt-3" }, [
                              _c("strong", [_vm._v("Recommandations")]),
                              _vm._v(" "),
                              _c(
                                "ul",
                                { staticClass: "csat-list" },
                                _vm._l(
                                  _vm.resultSummary.recommendations,
                                  function(item, index) {
                                    return _c("li", { key: "srec-" + index }, [
                                      _vm._v(_vm._s(item))
                                    ])
                                  }
                                ),
                                0
                              )
                            ])
                          ])
                        ],
                        1
                      )
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "v-layout",
                    { staticClass: "mt-4", attrs: { row: "", wrap: "" } },
                    [
                      _c(
                        "v-flex",
                        { staticClass: "pr-3", attrs: { xs12: "", md8: "" } },
                        [
                          _c("v-data-table", {
                            staticClass: "elevation-1",
                            attrs: {
                              headers: _vm.resultHeaders,
                              items: _vm.resultRows,
                              "rows-per-page-items": [10, 25, 50]
                            },
                            scopedSlots: _vm._u(
                              [
                                {
                                  key: "items",
                                  fn: function(props) {
                                    return [
                                      _c("tr", [
                                        _c("td", [
                                          _vm._v(
                                            _vm._s(props.item.conversation_id)
                                          )
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(_vm._s(props.item.visitor_id))
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _c("strong", [
                                            _vm._v(_vm._s(props.item.score))
                                          ])
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(_vm._s(props.item.label))
                                        ]),
                                        _vm._v(" "),
                                        _c("td", [
                                          _vm._v(_vm._s(props.item.summary))
                                        ])
                                      ])
                                    ]
                                  }
                                }
                              ],
                              null,
                              false,
                              2848767262
                            )
                          })
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "v-flex",
                        { staticClass: "pl-3", attrs: { xs12: "", md4: "" } },
                        [
                          _vm.resultErrors.length
                            ? _c(
                                "v-card",
                                { staticClass: "pa-3 csat-soft-card" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "subheading mb-2" },
                                    [_vm._v("Logs d'erreurs")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "ul",
                                    { staticClass: "csat-list" },
                                    _vm._l(_vm.resultErrors, function(
                                      item,
                                      index
                                    ) {
                                      return _c("li", { key: "err-" + index }, [
                                        _vm._v(
                                          "\n                " +
                                            _vm._s(
                                              item.conversation_id ||
                                                "conversation inconnue"
                                            ) +
                                            " - " +
                                            _vm._s(item.error) +
                                            "\n              "
                                        )
                                      ])
                                    }),
                                    0
                                  )
                                ]
                              )
                            : _vm._e()
                        ],
                        1
                      )
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        : _vm._e()
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-51e37d86", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-51e37d86","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/stats/CsatTrustScore.vue
// module id = null
// module chunks = 